import { QueryClient } from "@tanstack/react-query";

/**
 * Shared TanStack Query client.
 *
 * Defaults:
 *   - 60s staleTime — case data doesn't change second-to-second; one
 *     refetch per minute on focus is the right cadence for v0.
 *   - retry: 1 — privileged queries that fail RLS will fail repeatedly;
 *     don't hammer the database trying.
 *   - refetchOnWindowFocus: true — coming back to the tab gets fresh state.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
